/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import axios from 'api/request';
import { endPoints } from 'api/endpoints';
import { useParams } from 'react-router-dom';
import Select from 'components/select';
import { landingZoneData } from 'pages/app-profiles/store';
import ProvisioningStyles from 'pages/provisioning/storage/style';

const ConnectionType = ({ index }) => {
    const params = useParams();
    const { operation } = params;
    const [isTouched, setIsTouched] = React.useState(false);
    const [landingZoneForm, setLandingZoneForm] = useRecoilState(landingZoneData);
    const [options, setOptions] = React.useState([]);

    const connectionTypeApi = useMutation(() => axios.get(endPoints.landingZones.eipStack.connection));
    const setConnectionType = (connectionType, connectionTypeDetails) => {
        const form = { ...landingZoneForm };
        try {
            const result = form.connections.map((item, i) => {
                let obj = { ...item };
                if (index === i) {
                    obj = { ...obj, connectionType, connectionTypeDetails };
                }
                return obj;
            });
            form.connections = result;
        } catch (e) {
            // eslint-disable-next-line
            console.log(e);
        }
        setLandingZoneForm(form);
    };
    const resetOptions = () => {
        setOptions([]);
    };

    async function setPreconfig() {
        if (landingZoneForm?.connections?.[index].connectionTypeDetails) {
            const checkExist = await options.find((option) => landingZoneForm?.connections?.[index].connectionTypeDetails?.id === option?.data?.id);
            if (checkExist) {
                await setConnectionType(checkExist?.value, checkExist?.data);
            }
        }
    }
    const handleOnSelectChange = (selected) => {
        setConnectionType(selected?.value, selected?.data);
    };
    React.useEffect(() => {
        if (connectionTypeApi?.isSuccess) {
            setOptions(connectionTypeApi?.data?.data?.map((app) => ({ label: app.name, value: app.name, data: app })));
        }
    }, [connectionTypeApi?.isSuccess]);

    React.useEffect(() => {
        if (
            options &&
            operation === 'edit' &&
            !landingZoneForm?.connections?.[index].connectionType &&
            landingZoneForm?.connections?.[index].connectionTypeDetails
        ) {
            setPreconfig();
        }
    }, [options, landingZoneForm?.connections?.[index].connectionType]);

    React.useEffect(() => {
        resetOptions();
        connectionTypeApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!landingZoneForm?.connections?.[index]?.connectionType && landingZoneForm?.isTouched) setIsTouched(true);
    }, [landingZoneForm?.connections?.[index]?.connectionType, landingZoneForm?.isTouched]);
    return (
        <Stack direction="row" sx={ProvisioningStyles.stack}>
            <Select
                key="connectionTypeDetails"
                label="Connection Type*"
                value={landingZoneForm?.connections?.[index]?.connectionType || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                disabled={connectionTypeApi.isLoading}
                isLoading={connectionTypeApi.isLoading}
                isRequired={isTouched}
            />
        </Stack>
    );
};

ConnectionType.propTypes = {
    index: PropTypes.number,
};

ConnectionType.defaultProps = {
    index: 0,
};

export default React.memo(ConnectionType);
